import React from "react";
import { HelpCircle } from "feather-icons-react/build/IconComponents";

const BotaoAjuda = () => {
  const abrirAjuda = () => {
    window.open(
      "https://fosp.saude.sp.gov.br/conecta-sp/fale-conosco/",
      "_blank"
    );
  };

  return (
    <button className="botao-atendimento" onClick={abrirAjuda}>
      <HelpCircle /> <span className="texto-botao">Tire suas dúvidas</span>
    </button>
  );
};

export default BotaoAjuda;
